import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { BaseButton, ButtonTypes } from 'components/base/BaseButton';
import { Timer } from 'components/shared/Timer';
import { Popup } from 'components/UI/Popup';

import css from './limitTimeOfferPopupDefaultTheme.module.sass';

interface Props {
  onSubmit?: () => void;
  onClose?: () => void;
}

export const LimitTimeOfferPopupDefaultTheme: React.FC<Props> = ({
  onSubmit,
  onClose,
}) => {
  const { t } = useTranslation('app');

  return (
    <Popup popupClassName={css.popup} onClose={onClose}>
      <div className={css.root}>
        <section className={css.top}>
          <h3 className={css.title}>
            <Trans i18nKey="limitedTimeOffer.title" ns="app" />
          </h3>

          <p className={css.discount}>50</p>
          <p className={css.discountNext}>{`% ${t('limitedTimeOffer.off')}`}</p>

          <p className={css.prevDiscount}>
            {t('limitedTimeOffer.prevDiscount')}
          </p>
        </section>

        <section className={css.bottom}>
          <p className={css.timeText}>{t('limitedTimeOffer.timeLeft')}</p>
          <p className={css.time}>
            00:
            <Timer className={css.time} to={30 * 60} />
          </p>

          <BaseButton type={ButtonTypes.Accent} onClick={onSubmit}>
            {t('limitedTimeOffer.submitBtn')}
          </BaseButton>
        </section>
      </div>
    </Popup>
  );
};
